import { render, staticRenderFns } from "./pbblist.vue?vue&type=template&id=3b02ac10&scoped=true"
import script from "./pbblist.vue?vue&type=script&lang=js"
export * from "./pbblist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b02ac10",
  null
  
)

export default component.exports